import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export const notesRequiredCheck = (day: string): ValidatorFn => {
    return (control: AbstractControl): ValidationErrors | null => {
        const notesRequired = control.parent?.get('notesRequired')?.value;
        const notes = control.parent?.get(`${day}Notes`)?.value;

        if (!notesRequired) return null;

        if (control.value > 0 && (!notes || notes.trim() === '')) {
            return { notesRequired: true };
        }
        return null;
    };
};
